/**
 * Éligibilité édition affichage In-App vitrine (V1).
 */

import {
  DEFAULT_STOREFRONT_OBJECT_POSITION,
  resolveStorefrontObjectPositionFromMeta,
  sanitizeStorefrontObjectPosition,
} from './storefrontObjectPosition.js';

const EDITABLE_STATUSES = new Set(['SENT', 'PARTIAL']);

export function isInAppStorefrontEditable(campaign, now = new Date()) {
  if (!campaign || typeof campaign !== 'object') return false;
  const channels = campaign.channels || [];
  if (!channels.includes('IN_APP')) return false;
  if (!EDITABLE_STATUSES.has(campaign.status)) return false;
  if (!campaign.storefrontEnabled) return false;
  const until = campaign.storefrontDisplayUntil
    ? new Date(campaign.storefrontDisplayUntil)
    : null;
  if (!until || Number.isNaN(until.getTime())) return false;
  return until.getTime() > now.getTime();
}

export function campaignHasEmailChannel(campaign) {
  return Array.isArray(campaign?.channels) && campaign.channels.includes('EMAIL');
}

/**
 * Préremplit le formulaire depuis la campagne enrichie (GET détail).
 * Préfère `inAppDisplay` (snapshot résolu côté API) puis champs GrowthCampaign.
 */
export function hydrateInAppEditForm(campaign) {
  const display =
    campaign?.inAppDisplay && typeof campaign.inAppDisplay === 'object'
      ? campaign.inAppDisplay
      : null;
  const meta = campaign?.meta && typeof campaign.meta === 'object' ? campaign.meta : {};

  const title = display?.title ?? campaign?.title ?? '';
  const message = display?.message ?? campaign?.textContent ?? '';
  const imageUrl = display?.imageUrl ?? meta.imageUrl ?? '';
  const ctaLabel = display?.ctaLabel ?? meta.ctaLabel ?? '';
  const ctaUrl = display?.ctaUrl ?? meta.ctaUrl ?? '';
  const untilRaw =
    display?.storefrontDisplayUntil ?? campaign?.storefrontDisplayUntil ?? null;
  const storefrontObjectPosition = sanitizeStorefrontObjectPosition(
    display?.storefrontObjectPosition ??
      resolveStorefrontObjectPositionFromMeta(meta)
  );

  return {
    title: title || '',
    message: message || '',
    imageUrl: imageUrl || '',
    ctaLabel: ctaLabel || '',
    ctaUrl: ctaUrl || '',
    storefrontDisplayUntil: untilRaw ? toDatetimeLocalValue(untilRaw) : '',
    storefrontObjectPosition,
  };
}

function toDatetimeLocalValue(iso) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function datetimeLocalToIso(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export { DEFAULT_STOREFRONT_OBJECT_POSITION, sanitizeStorefrontObjectPosition };
